import { Layout } from "components/Layout/Layout";
import { RelayService } from "components/RelayService/RelayService";
import { FC } from "react";
import { usePageTracking } from "react-event-tracker";
import { ManageAccountContent } from "./ManageAccountContent";

export const ManageAccount: FC = () => {
  usePageTracking({
    page: {
      pageType: "details-page",
      siteSection: "accounts",
      siteSubSection: "manage",
      pageTitle: "overview",
    },
    user: {
      authenticationStatus: "logged in",
    },
  });
  return (
    <Layout>
      <Layout.Header>Manage account</Layout.Header>
      <Layout.Main>
        <ManageAccountContent />
      </Layout.Main>
      <Layout.Sidebar>
        <RelayService />
      </Layout.Sidebar>
    </Layout>
  );
};
